export default "__VITE_ASSET__v67pL8uB__"